import api from './api';

const FR_CI_FALLBACK = {
  preset_key:          'fr_ci',
  currency_label:      'FCFA',
  placement:           'suffix',
  amount_decimals:     0,
  rate_decimals:       2,
  thousands_separator: 'space',
  decimal_separator:   'comma',
  date_format:         'dd/mm/yyyy',
  negative_style:      'parentheses',
};

let cachedBundle = null;
let inflightPromise = null;

async function fetchBundle() {
  if (cachedBundle) return cachedBundle;
  if (inflightPromise) return inflightPromise;
  inflightPromise = api.request('/formatting')
    .then(bundle => {
      cachedBundle = bundle;
      inflightPromise = null;
      return cachedBundle;
    })
    .catch(() => {
      cachedBundle = { ...FR_CI_FALLBACK };
      inflightPromise = null;
      return cachedBundle;
    });
  return inflightPromise;
}

export async function loadFormatting() {
  return fetchBundle();
}

export async function refreshFormatting() {
  cachedBundle = null;
  inflightPromise = null;
  return fetchBundle();
}

export function getFormatting() {
  return cachedBundle || FR_CI_FALLBACK;
}
